import { useRef } from 'react'
import { useTranslation } from 'react-i18next'

import { Widget } from '../../../../../Widget'
import { useListingProfileContext } from '../../RentalPortalListingProfile.hooks'
import { getListingProfileWidgetActionsProps } from '../../RentalPortalListingProfile.utils'

import { QA_NAME_LISTING_PROFILE_KEY_FACTS_WIDGET } from './RentalPortalListingProfileKeyFactsWidget.constants'
import { RentalPortalListingProfileKeyFactsWidgetContent } from './RentalPortalListingProfileKeyFactsWidgetContent'

function RentalPortalListingProfileKeyFactsWidget() {
  const { t } = useTranslation()

  const { isInitiated, isPreview, listingData } = useListingProfileContext()

  const containerRef = useRef(null)

  return (
    <Widget
      headerProps={{
        contentProps: {
          actionsProps: getListingProfileWidgetActionsProps({
            isPreview,
            listingData,
          }),
        },
      }}
      isSkeleton={!isInitiated || !listingData}
      qaName={QA_NAME_LISTING_PROFILE_KEY_FACTS_WIDGET}
      ref={containerRef}
      title={t('RentalPortal.ListingProfileKeyFactsTitleKey')}
    >
      <RentalPortalListingProfileKeyFactsWidgetContent
        containerRef={containerRef}
      />
    </Widget>
  )
}

export default RentalPortalListingProfileKeyFactsWidget
